import O1HD from "../../engines/gameEngine";
import { BUNDLE_SMALL_NAME, getOneBundleOnePrefab } from "../../modes/normalMode/BundleResourceConfig";
import NormalGameManager from "../../modes/normalMode/manager/NormalGameManager";
import { pawnShopFixGameSelectDataI } from "../pawnShopGame/pawnShop/const/pawnShopConst";
import pawnShopFixGameResult from "./pawnShopFixGameResult";
import pawnShopFixGameSelectPage from "./pawnShopFixGameSelectPage";

const {ccclass, property} = cc._decorator;

@ccclass
export default class pawnShopFixGame extends cc.Component {

    @property({type:cc.Node,displayName:"问题节点"})
    questionNode:cc.Node = null;

    @property({type:cc.Node,displayName:"答案节点"})
    answerNode:cc.Node = null;

    @property({type:cc.Sprite,displayName:"需要发光的节点"})
    needLightNode:cc.Sprite = null;

    @property({type:cc.Material,displayName:"发光材质"})
    lightMaterial:cc.Material = null;

    data:pawnShopFixGameSelectDataI = null;

    startPos:cc.Vec2 = null;

    page:pawnShopFixGameSelectPage = null;

    bindData(data:pawnShopFixGameSelectDataI,page:pawnShopFixGameSelectPage){
        this.data = data;
        this.page = page;
    }

    triggerAry:number[] = [];
    
    start(): void {
        this.loadGame(); 
    }

    loadGame(){
        this.answerNode.children.forEach((n:cc.Node)=>{
            this.addOneNodeEvent(n);
        });
    }

    addOneNodeEvent(node:cc.Node){
        node.on("touchstart",this.onTouchStartOneAnswer,this);
        node.on("touchmove",this.onTouchMoveOneAnswer,this);
        node.on("touchcancel",this.onTouchEndOneAnswer,this);
        node.on("touchend",this.onTouchEndOneAnswer,this);
    }

    removeOneNodeEvent(node:cc.Node){
        node.off("touchstart",this.onTouchStartOneAnswer,this);
        node.off("touchmove",this.onTouchMoveOneAnswer,this);
        node.off("touchcancel",this.onTouchEndOneAnswer,this);
        node.off("touchend",this.onTouchEndOneAnswer,this);
    }

    onTouchStartOneAnswer(e:cc.Event.EventTouch){
        let targetNode:cc.Node = e.target;
        let outLineNode:cc.Node = targetNode.getChildByName("outLine");
        outLineNode.color = cc.color(84,255,0);
        this.startPos = targetNode.getPosition().clone();
        targetNode.zIndex = 100;
    }

    onTouchMoveOneAnswer(e:cc.Event.EventTouch){
        let detal = e.getDelta();
        let targetNode:cc.Node = e.target;
        targetNode.x += detal.x;
        targetNode.y += detal.y;
    }

    onTouchEndOneAnswer(e:cc.Event.EventTouch){
        let targetNode:cc.Node = e.target;
        let outLineNode:cc.Node = targetNode.getChildByName("outLine");
        outLineNode.color = cc.color(0,0,0);
        let triggerNode:cc.Node = targetNode.getChildByName("trigger");
        let node:cc.Node = this.questionNode.children.find((n:cc.Node)=>{
            let nTrigger:cc.Node = n.getChildByName("trigger");
            return triggerNode.getBoundingBoxToWorld().intersects(nTrigger.getBoundingBoxToWorld()) && targetNode.name == n.name && !this.triggerAry.includes(n.getSiblingIndex()); 
        });
        let speed:number = 600;
        let needTime:number = 0;
        if(node){
            // 碰到了需要的节点 位置矫正
            targetNode.zIndex = node.zIndex;
            this.triggerAry.push(node.getSiblingIndex());
            let targetPos:cc.Vec2 = targetNode.parent.convertToNodeSpaceAR(node.convertToWorldSpaceAR(cc.v2()));
            needTime = targetPos.sub(targetNode.getPosition()).mag() / speed;
            this.removeOneNodeEvent(targetNode);
            let length = this.triggerAry.length;
            //@ts-ignore
            cc.tween(targetNode).to(needTime,{position:targetPos}).call(()=>{
                if(length == this.answerNode.childrenCount){
                    this.needLightNode.setMaterial(0,this.lightMaterial);
                }
            }).delay(3).call(()=>{
                if(length == this.answerNode.childrenCount){
                    this.win();               
                }
            }).start();
        }else{
            // 没有碰到需要的节点 回到原位置
            needTime = targetNode.getPosition().sub(this.startPos).mag() / speed;
            //@ts-ignore
            cc.tween(targetNode).to(needTime,{position:this.startPos}).start();
        }
    }

    async win(){
        let oData = this.data.obj;
        let data = NormalGameManager._instance.pawnShopManager.addOneFixCount(oData,this.data.index);
        this.data = {
            obj:data,
            index:this.data.index
        }
        let url:string = "prefab/fixGame/pawnShopFixGameResult";
        let prefab = await getOneBundleOnePrefab(BUNDLE_SMALL_NAME.pawnShopGameBundle,url);
        let pawnGame:cc.Node = cc.instantiate(prefab);
        let ps = pawnGame.getComponent(pawnShopFixGameResult);
        ps.bindData(this.data,this.page);
        pawnGame.setParent(O1HD.Canvas()); 
        this.closeThis();
    }

    closeThis(){
        this.node.destroy();
        this.node.removeFromParent();
    }

    onBtnClose(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.closeThis();
    }

}
